import { render, staticRenderFns } from "./LoginOptions.vue?vue&type=template&id=7f86ca01&scoped=true"
import script from "./LoginOptions.vue?vue&type=script&lang=js"
export * from "./LoginOptions.vue?vue&type=script&lang=js"
import style0 from "./LoginOptions.vue?vue&type=style&index=0&id=7f86ca01&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f86ca01",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f86ca01')) {
      api.createRecord('7f86ca01', component.options)
    } else {
      api.reload('7f86ca01', component.options)
    }
    module.hot.accept("./LoginOptions.vue?vue&type=template&id=7f86ca01&scoped=true", function () {
      api.rerender('7f86ca01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/pages/login/LoginOptions.vue"
export default component.exports